import classNames from 'classnames'
import type { JSX } from 'react'

import { LoyaltyTierDto } from '@model/IntroducingBrokerDetailsDto'

import { LoyaltyTierMapped } from '../../Loyalty/Loyalty'
import { LoyaltyCard } from './LoyaltyCard/LoyaltyCard'

import styles from '../../Loyalty/LoyaltyPage.module.scss'

interface Props {
  showFadeLeft: boolean
  showFadeRight: boolean
  handleScroll: () => void
  onSubmitReward: (tier?: LoyaltyTierDto | LoyaltyTierMapped | null) => Promise<void>
  loyaltyTiers: LoyaltyTierMapped[]
  sliderRef: React.MutableRefObject<HTMLDivElement | null>
  cardRefs: React.MutableRefObject<(HTMLDivElement | null)[]>
}

export const LoyaltyTiersSlider = (props: Props): JSX.Element => {
  const {
    showFadeLeft,
    showFadeRight,
    handleScroll,
    onSubmitReward,
    loyaltyTiers,
    sliderRef,
    cardRefs,
  } = props

  return (
    <div className={styles.sliderWrapper}>
      <div
        className={classNames(styles.fade, styles.fadeLeft, {
          [styles.showFadeLeft]: showFadeLeft,
        })}
        data-slider-fade-left
      />
      <div
        className={classNames(styles.fade, styles.fadeRight, {
          [styles.showFadeRight]: showFadeRight,
        })}
        data-slider-fade-right
      />
      <div
        className={styles.slider}
        ref={sliderRef}
        onScroll={handleScroll}
        role='region'
        aria-label='Loyalty tiers slider'
      >
        <div className={styles.sliderOffsetPlaceholder} />
        {loyaltyTiers.map((tier, index) => (
          <div
            key={tier.id}
            ref={(el) => {
              cardRefs.current[index] = el
            }}
          >
            <LoyaltyCard tier={tier} onSubmitReward={onSubmitReward} />
          </div>
        ))}
      </div>
    </div>
  )
}
